<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="contactInfo">
            <van-loading
                class="pageLogin"
                v-if="isloading"
                type="spinner"
                color="#1989fa"
            ></van-loading>
            <van-nav-bar
                title="联系人信息"
                left-text="联系人"
                left-arrow
                @click-left="onClickLeft"
            >
            </van-nav-bar>
            <section class="userInfo">
                <div class="info">
                    <img
                        v-if="contactDnfoData.User_Gender == 1"
                        class="van_left"
                        src="@/assets/images/addressBook/b_head_portrait_man@2x.png"
                        alt="头像"
                    >
                    <img
                        v-else-if="contactDnfoData.User_Gender == 0"
                        class="van_left"
                        src="@/assets/images/addressBook/b_head_portrait_woman@2x.png"
                        alt="头像"
                    >
                    <img
                        v-else
                        class="van_left"
                        src="@/assets/images/addressBook/default.png"
                        alt="头像"
                    >
                    <div class="van_left">
                        <p>{{ contactDnfoData.User_Name }}</p>
                        <span>{{ contactDnfoData.Dept_Name }}</span>
                    </div>
                </div>
                <ul>
                    <li>
                        <div>
                            <img src="@/assets/images/addressBook/icon_age@2x.png" alt="年龄">
                            <span>年龄</span>
                        </div>
                        <div>{{ contactDnfoData.User_Age }}</div>
                    </li>
                    <li>
                        <div>
                            <img src="@/assets/images/addressBook/icon_sex@2x.png" alt="性别">
                            <span>性别</span>
                        </div>
                        <div v-if="contactDnfoData.User_Gender == 1">
                            男
                        </div>
                        <div v-if="contactDnfoData.User_Gender == 0">
                            女
                        </div>
                    </li>
                    <li>
                        <div>
                            <img src="@/assets/images/addressBook/icon_post@2x.png" alt="职务">
                            <span>职务</span>
                        </div>
                        <div>{{ contactDnfoData.User_Post }}</div>
                    </li>
                    <li>
                        <div>
                            <img src="@/assets/images/addressBook/icon_main_2@2x.png" alt="编号">
                            <span>编号</span>
                        </div>
                        <div>{{ contactDnfoData.User_Code }}</div>
                    </li>
                    <li>
                        <div>
                            <img src="@/assets/images/icons/icon_gy_8.png" alt="所属公司">
                            <span>所属公司</span>
                        </div>
                        <div>{{ contactDnfoData.Org_Name }}</div>
                    </li>
                    <li>
                        <div>
                            <img src="@/assets/images/icons/icon_3.png" alt="账号">
                            <span>账号</span>
                        </div>
                        <div>{{ contactDnfoData.Login_Name }}</div>
                    </li>
                    <li>
                        <div>
                            <img src="@/assets/images/icons/icon_4.png" alt="联系电话">
                            <span>联系电话</span>
                        </div>
                        <div>{{ contactDnfoData.Mobile }}</div>
                    </li>
                    <li>
                        <div>
                            <img src="@/assets/images/icons/icon_25.png" alt="邮箱">
                            <span> 邮箱</span>
                        </div>
                        <div>{{ contactDnfoData.Email }}</div>
                    </li>
                </ul>
                <button
                    class="iconfont iconliaotianxianxing"
                    @click="personalChat"
                    v-if="accId != ''"
                >
                    发起聊天
                </button>
                <button
                    class="iconfont icontianjialianxiren"
                    v-if="isAddButton && accId != '' && isAdded == false"
                    @click="addContact"
                >
                    添加联系人
                </button>
                <button
                    class="unregistered"
                    v-if="isAdded == true"
                >
                    已添加用户为好友
                </button>
                <button
                    class="unregistered"
                    v-if="accId == ''"
                >
                    用户未注册
                </button>
            </section>
        </div>
    </v-touch>
</template>

<script>

export default {
    // 联系人信息
    name: 'contact-info',
    components: {},
    props: {},
    data() {
        return {
            // 加载中状态
            isloading: false,
            // 联系人信息
            contactDnfoData: {},
            // 是否显示添加好友按钮
            isAddButton: false,
            // 是否已添加
            isAdded: false,
            // 云信id
            accId: '',
        };
    },
    computed: {},
    watch: {},
    created() {
        // 获取联系人信息
        this.gitContactInfo();
        if (this.$route.query.isFriend) {
            this.isAddButton = false;
        } else {
            this.isAddButton = true;
        }
    },
    mounted() {},
    destroyed() {},
    methods: {
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 获取联系人信息
        gitContactInfo() {
            this.isloading = true;
            this.$axios
                .get('/interfaceApi/basicplatform/users/' + this.$route.query.User_Id)
                .then(res => {
                    this.contactDnfoData = res;
                    this.gitUserAccid();
                }).catch(error => {
                    this.isloading = false;
                    this.$dialog({ message: error.ErrorCode.Message });
                });
        },
        // 获取联系人云信id
        gitUserAccid() {
            this.$axios
                .post('/interfaceApi/message/MessageNetease/get_users_accid/' + this.contactDnfoData.User_Id)
                .then(res => {
                    this.accId = res;
                    this.isloading = false;
                }).catch(error => {
                    this.isloading = false;
                    this.$dialog({ message: error });
                });
        },
        // 添加联系人
        addContact() {
            this.isloading = true;
            this.$axios
                .post('/interfaceApi/message/MessageNetease/betch_add_user_friend', [
                    {
                        user_id: this.$takeTokenParameters('Uid'),
                        friend_id: this.contactDnfoData.User_Id,
                        friend_name: this.contactDnfoData.User_Name,
                        friend_org_id: this.contactDnfoData.Org_ID,
                        friend_org_name: this.contactDnfoData.Org_Name,
                    },
                ])
                .then(res => {
                    this.$toast.success(res);
                    this.isloading = false;
                    this.isAdded = true;
                }).catch(error => {
                    this.isloading = false;
                    this.$dialog({ message: error.ErrorCode.Message });
                });
        },
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 点发起聊天进入聊天界面
        personalChat() {
            const callMobileData = {
                conversationId: this.accId,
                name: this.contactDnfoData.User_Name,
                type: '0',
            };
            this.$callMobile('JYTeamsNative', 'GetConversationInfo', callMobileData);
        },
    },
};
</script>
<style lang="stylus">
.contactInfo
    background #F0F0F0
    .userInfo
        .info
            height 92rpx
            margin-bottom 16rpx
            padding 16rpx
            background #fff
            img
                width 60rpx
                height 60rpx
                // background red
                border-radius 50%
                margin-right 16rpx
            >div
                width calc(100% - 80rpx)
                p,span
                    max-width 100%
                    display block
                    overflow hidden
                    text-overflow ellipsis
                    white-space nowrap
                p
                    font-size 18rpx
                    line-height 36rpx
                    color #333
                span
                    font-size 12rpx
                    color #979EA7
    ul
        margin-bottom 16rpx
        li
            height 44rpx
            margin-bottom 1px
            background #fff
            padding 0 16rpx
            div
                line-height 44rpx
                &:nth-of-type(1)
                    float left
                    font-size 16rpx
                    color #333333
                    img,span
                        float left
                    img
                        width 16rpx
                        height 16rpx
                        margin 13rpx 14rpx 13rpx 0
                &:nth-of-type(2)
                    float right
                    font-size 14rpx
                    color #979EA7
    button
        width 100%
        height 45rpx
        border none
        background #ffffff
        color #3495FB
        font-size 16rpx
        margin-bottom 1px
        &.unregistered
            color #ccc
</style>